import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CompanyService {
    private companySubject = new BehaviorSubject<any>(null);
    company$ = this.companySubject.asObservable();

    public isCardioLocked = false;
    public isNephroLocked = false;
    public activatedServices = {};

    constructor(private http: HttpClient) {}

    getCompany(id) {
        return this.http.get<any>(`${environment.apiUrl}/company/${id}`).pipe(
            map(({ company }) => {
                if (company.services.cardio) {
                    this.isCardioLocked = true;
                }
                if (company.services.nephro) {
                    this.isNephroLocked = true;
                }
                return company;
            }),
        );
    }

    updateCompany(id, page, body) {
        return this.http
            .put<any>(`${environment.apiUrl}/company/${id}/${page}`, body)
            .pipe(
                map(({ company }) => {
                    if (company.services.cardio) {
                        this.isCardioLocked = true;
                    }
                    if (company.services.nephro) {
                        this.isNephroLocked = true;
                    }
                    return company;
                }),
            );
    }

    updateCompanyStatus(id, status) {
        return this.http
            .put<any>(`${environment.apiUrl}/company/${id}/status`, { status })
            .pipe(map(({ company }) => company));
    }

    getFollowedPatients(fields) {
        return this.http.get(
            `${environment.apiUrl}/company/followed-patients`,
            {
                params: fields,
            },
        );
    }

    getSimpleUsersForCompany(companyId) {
        return this.http.get<any>(
            `${environment.apiUrl}/users-ums/simple/${companyId}`,
        );
    }

    deleteDefaultUser(companyId, body, service) {
        return this.http.put<any>(
            `${environment.apiUrl}/delete-default-user/${companyId}/${service}`,
            body,
        );
    }

    deleteExternUser(companyId, body, service) {
        return this.http.put<any>(
            `${environment.apiUrl}/delete-extern-user/${companyId}/${service}`,
            body,
        );
    }

    setCompany(company) {
        this.companySubject.next(company);
    }

    changeCompanyStatus(companyId, status) {
        return this.http.put<any>(
            `${environment.apiUrl}/company/change-status/${companyId}`, { status },
        );
    }
}
